<template>
  <section class="resume-section" id="skills">
    <div class="resume-section-content">
    <h2 class="mb-5">{{ skills }}</h2>
    <!-- Programming Skills -->
    <div class="subheading mb-3">{{ programming }}</div>
    <!-- Dev Icons -->
    <ul class="list-inline dev-icons">
      <li class="list-inline-item"><i class="fab fa-html5"></i></li>
      <li class="list-inline-item"><i class="fab fa-css3-alt"></i></li>
      <li class="list-inline-item"><i class="fab fa-js-square"></i></li>
      <li class="list-inline-item"><i class="fab fa-react"></i></li>
      <li class="list-inline-item"><i class="fab fa-node-js"></i></li>
      <li class="list-inline-item"><i class="fab fa-java"></i></li>
      <li class="list-inline-item"><i class="fab fa-python"></i></li>
      <li class="list-inline-item"><i class="fab fa-npm"></i></li>
    </ul>
    <!-- Tech Skills -->
    <ul class="fa-ul mb-0">
      <li v-for="(skill, index) in techSkills" :key="'skill-' + index">
        <span class="fa-li"><i class="fas fa-check"></i></span>
        {{ skill }}
      </li>
    </ul>
    <!-- Other Skills -->
    <div class="subheading mt-3 mb-3">{{ other }}</div>
    <ul class="fa-ul mb-0">
      <li v-for="(skill, index) in otherSkills" :key="'skill-' + index">
        <span class="fa-li"><i class="fas fa-check"></i></span>
        {{ skill }}
      </li>
    </ul>
    <!-- Workflows -->
    <div class="subheading mt-3 mb-3">{{ workflow }}</div>
    <ul class="fa-ul mb-0">
      <li v-for="(skill, index) in workflows" :key="'skill-' + index">
        <span class="fa-li"><i class="fas fa-check"></i></span>
        {{ skill }}
      </li>
    </ul>
  </div>
  </section>
</template>

<script>
export default {
  methods: {
    changeLanguage(event) {
      this.$i18n.locale = event.target.value;
    }
  },
  computed: {
    skills() {
      return this.$t('sections.skills')
    },
    programming() {
      return this.$t('skills.programming')
    },
    other() {
      return this.$t('skills.other')
    },
    workflow() {
      return this.$t('skills.workflow')
    },
    techSkills() {
      return this.$i18n.messages[this.$i18n.locale].skills.techSkills;
    },
    otherSkills() {
      return this.$i18n.messages[this.$i18n.locale].skills.otherSkills;
    },
    workflows() {
      return this.$i18n.messages[this.$i18n.locale].skills.workflows;
    }
  }
};
</script>